<template>
  <li class="flex flex-col lg:flex-row lg:item-center gap-3">
    <NuxtLink :to="article._path" class="shrink-0">
      <img
        v-if="article.image?.src"
        :src="article.image.src"
        :alt="article.image.alt"
        class="object-cover object-center block rounded-lg lg:rounded lg:w-28 lg:h-28 max-w-full sm:max-w-[30rem]"
      />
    </NuxtLink>
    <div class="lg:flex lg:flex-col lg:justify-center">
      <HeadingBasic :size="2" class="mb-3">
        <NuxtLink
          class="hover:text-cardinal dark:hover:text-cardinal-300"
          :to="article._path"
          style="text-wrap: pretty"
        >
          {{ article.title }}
        </NuxtLink>
      </HeadingBasic>
      <ArticleAuthorDate :article="article" />
      <NuxtLink
        class="hover:text-cardinal dark:hover:text-cardinal-300 mt-5 block underline"
        :to="article._path"
        style="text-wrap: pretty"
      >
        Read Article
      </NuxtLink>
    </div>
  </li>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/types/blog-post';
defineProps<{
  article: BlogPost;
}>();
</script>
